/**
 * PrivateRoute Component
 * Purpose: Protects routes that require authentication
 * Redirects to login page if user is not authenticated
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/api';

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
